module.exports = __webpack_public_path__ + "20-lined-443da75bb86bd334e05e4c8b954546de.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/step-number-icons/lined/20-lined.svg
// module id = 131
// module chunks = 0